var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFreeSpins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM19 16L23 12L27 16H24C24 18.1217 23.1571 20.1566 21.6569 21.6569C20.1566 23.1572 18.1217 24 16 24C14.43 24 12.97 23.54 11.74 22.76L13.2 21.3C14.03 21.75 15 22 16 22C17.5913 22 19.1174 21.3679 20.2426 20.2426C21.3679 19.1174 22 17.5913 22 16H19ZM11.7574 11.7574C10.6321 12.8826 10 14.4087 10 16H13L9 20L5 16H8C8 13.8783 8.84285 11.8434 10.3431 10.3431C11.8434 8.84285 13.8783 8 16 8C17.57 8 19.03 8.46001 20.26 9.24001L18.8 10.7C17.97 10.25 17 10 16 10C14.4087 10 12.8826 10.6321 11.7574 11.7574Z",
    fill: "#A1AAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeSpins);
export default __webpack_public_path__ + "static/media/free-spins.ab648a53.svg";
export { ForwardRef as ReactComponent };